import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32ac7042"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "notification is-warning"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.google.com/intl/fr/chrome/",
      target: "_blank"
    }, "Google Chrome")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.microsoft.com/fr-fr/edge/download",
      target: "_blank"
    }, "Microsoft Edge")
  ])
], -1))
const _hoisted_3 = {
  key: 1,
  class: "box"
}
const _hoisted_4 = {
  key: 2,
  class: "box"
}
const _hoisted_5 = { class: "media" }
const _hoisted_6 = { class: "media-left" }
const _hoisted_7 = {
  key: 0,
  class: "subtitle is-4"
}
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "subtitle is-5" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = {
  key: 0,
  class: "media-content ml-5"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Merci de fermer le programme ADB afin de pouvoir utiliser cet outil. ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("pre", null, "adb kill-server", -1))
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 1,
  class: "media-content ml-5"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Chargement du périphérique...", -1))
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_pico_g2 = _resolveComponent("pico-g2")!
  const _component_pico_g3 = _resolveComponent("pico-g3")!
  const _component_phone = _resolveComponent("phone")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isCompatible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('config.usbApiWarning.title')), 1),
          _createElementVNode("div", null, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('config.usbApiWarning.message')), 1),
            _hoisted_2
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('config.thanks')), 1),
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('config.teamThanks')), 1)
        ]))
      : (_ctx.device == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "button is-small",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addDevice && _ctx.addDevice(...args)))
            }, _toDisplayString(_ctx.$t('config.addDevice')), 1),
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('usb.warning')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('usb.why')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('usb.action')), 1)
          ]))
        : (_ctx.device)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("article", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.device.deviceName)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(_ctx.device.manufacturer) + " (" + _toDisplayString(_ctx.device.deviceName) + ") ", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.device.modelName), 1),
                  _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.device.serial), 1),
                  (_ctx.device?.deviceName)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$t('config.systemVersion')) + ": " + _toDisplayString(_ctx.device.systemVersion), 1))
                    : _createCommentVNode("", true),
                  (_ctx.device?.wifi)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                        _createTextVNode(" Wifi: "),
                        (_ctx.device?.wifi.enabled)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                              _createTextVNode(_toDisplayString(_ctx.$t('config.wifi.active.title')) + " ", 1),
                              (_ctx.device?.wifi.connected)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('config.wifi.active.connected')), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('config.wifi.active.disconnected')), 1))
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('config.wifi.disabled')), 1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.device?.battery)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                        (!_ctx.device?.battery.present)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('config.battery.notDetected')), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('config.battery.chargedAt', { percent: _ctx.device?.battery.percent })), 1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.device?.currentDate)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, " Date courante: " + _toDisplayString(_ctx.device.currentDate.toLocaleDateString()), 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.device && _ctx.deviceLoaded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_ctx.error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            (_ctx.error.endsWith('Unable to claim interface.'))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _createElementVNode("h3", null, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: _ctx.warning(),
                                      class: "red"
                                    }, null, 8, ["icon"]),
                                    _createTextVNode(" ADB semble être en cours d'utilisation. ")
                                  ]),
                                  _hoisted_23,
                                  _hoisted_24
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _createElementVNode("h3", null, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: _ctx.warning(),
                                      class: "red"
                                    }, null, 8, ["icon"]),
                                    _createTextVNode(" Une erreur inconnue est apparue. ")
                                  ]),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
                                ]))
                          ]))
                        : (_ctx.device.is(_ctx.DeviceType.PicoG2))
                          ? (_openBlock(), _createBlock(_component_pico_g2, {
                              key: 1,
                              serial: _ctx.device.serial
                            }, null, 8, ["serial"]))
                          : (_ctx.device.is(_ctx.DeviceType.PicoG3))
                            ? (_openBlock(), _createBlock(_component_pico_g3, {
                                key: 2,
                                serial: _ctx.device.serial
                              }, null, 8, ["serial"]))
                            : (_ctx.device.is(_ctx.DeviceType.Phone))
                              ? (_openBlock(), _createBlock(_component_phone, {
                                  key: 3,
                                  serial: _ctx.device.serial
                                }, null, 8, ["serial"]))
                              : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}